// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
   BASE STYLES
   ============================================================================ */
.app {
  min-height: 100vh;
  padding: 20px;
}

/* ============================================================================
   BUTTONS
   ============================================================================ */
.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.btn-secondary:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.2);
}

.btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-back {
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  padding: 8px 16px;
}

.btn-back:hover {
  color: white;
}

.btn-delete {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
  padding: 8px 16px;
  font-size: 14px;
}

.btn-delete:hover:not(:disabled) {
  background: rgba(239, 68, 68, 0.3);
}

.btn-delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-edit {
  background: rgba(102, 126, 234, 0.2);
  color: #667eea;
  padding: 8px 16px;
  font-size: 14px;
}

.btn-edit:hover {
  background: rgba(102, 126, 234, 0.3);
}

.btn-full {
  width: 100%;
  justify-content: center;
}

.btn-small {
  padding: 8px 16px;
  font-size: 14px;
}

/* ============================================================================
   HOME SCREEN
   ============================================================================ */
.home-container {
  max-width: 800px;
  margin: 0 auto;
  padding-top: 60px;
}

.hero {
  text-align: center;
  margin-bottom: 40px;
}

.hero h1 {
  font-size: 48px;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #fff 0%, #a5b4fc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 18px;
  margin-bottom: 32px;
}

.hero-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.stats-row {
  display: flex;
  gap: 20px;
  margin-bottom: 40px;
}

.stats-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  padding: 32px;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
  flex: 1 1;
}

.stat-number {
  font-size: 48px;
  font-weight: 700;
  color: #667eea;
  display: block;
}

.stat-label {
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Quiz list on home page */
.quizzes-section {
  margin-top: 40px;
}

.quizzes-section h3 {
  margin-bottom: 20px;
  color: rgba(255, 255, 255, 0.8);
}

.quizzes-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.quiz-list-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  transition: all 0.3s ease;
}

.quiz-list-card:hover {
  border-color: rgba(102, 126, 234, 0.3);
  background: rgba(255, 255, 255, 0.08);
}

.quiz-list-info {
  flex: 1 1;
  min-width: 0;
}

.quiz-list-info h4 {
  margin: 0 0 8px 0;
  font-size: 18px;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quiz-list-description {
  margin: 0 0 8px 0;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quiz-list-meta {
  color: rgba(255, 255, 255, 0.4);
  font-size: 13px;
}

.quiz-list-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: rgba(255, 255, 255, 0.5);
}

.loading {
  text-align: center;
  padding: 60px 20px;
  color: rgba(255, 255, 255, 0.6);
}

/* ============================================================================
   MODAL
   ============================================================================ */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 20px;
  padding: 32px;
  max-width: 500px;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.modal-header h3 {
  margin: 0;
  font-size: 24px;
}

.modal-close {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 28px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.modal-close:hover {
  color: white;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
}

/* ============================================================================
   QUIZ MANAGER
   ============================================================================ */
.quiz-manager-container {
  max-width: 900px;
  margin: 0 auto;
}

.header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 32px;
}

.header h2 {
  font-size: 28px;
  margin: 0;
}

/* Quiz info card */
.quiz-info-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 24px;
}

.quiz-info-display {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.quiz-info-text h3 {
  margin: 0 0 8px 0;
  font-size: 24px;
}

.quiz-info-text p {
  margin: 0 0 8px 0;
  color: rgba(255, 255, 255, 0.6);
}

.quiz-meta {
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
}

.quiz-info-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.quiz-info-edit .form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
}

/* Share section */
.share-section {
  background: rgba(102, 126, 234, 0.1);
  border-radius: 16px;
  padding: 20px;
  border: 1px solid rgba(102, 126, 234, 0.2);
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.share-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.share-label {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  white-space: nowrap;
}

.share-url {
  background: rgba(0, 0, 0, 0.3);
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  color: #a5b4fc;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  min-width: 0;
}

.share-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

/* Add question section */
.add-question-section {
  margin-bottom: 40px;
}

.add-question-section h3 {
  margin-bottom: 20px;
  color: rgba(255, 255, 255, 0.8);
}

/* Questions section */
.questions-section {
  margin-top: 40px;
}

.questions-section h3 {
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 0.8);
}

.drag-hint {
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  margin-bottom: 16px;
}

.empty-questions {
  text-align: center;
  padding: 40px 20px;
  color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.03);
  border-radius: 16px;
  border: 1px dashed rgba(255, 255, 255, 0.1);
}

/* ============================================================================
   QUESTION FORM
   ============================================================================ */
.question-form {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  padding: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.question-form.editing {
  background: rgba(102, 126, 234, 0.05);
  border-color: rgba(102, 126, 234, 0.2);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 14px 18px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.2);
  color: white;
  font-size: 16px;
  font-family: inherit;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
}

.form-group textarea {
  min-height: 100px;
  resize: vertical;
}

.options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

@media (max-width: 600px) {
  .options-grid {
    grid-template-columns: 1fr;
  }
}

.option-group {
  position: relative;
}

.option-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.option-badge {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  color: white;
}

.option-badge.a { background: #ef4444; }
.option-badge.b { background: #3b82f6; }
.option-badge.c { background: #10b981; }
.option-badge.d { background: #f59e0b; }

.correct-answer-selector {
  display: flex;
  gap: 12px;
}

.answer-btn {
  width: 50px;
  height: 50px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  background: transparent;
  color: white;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;
}

.answer-btn:hover {
  border-color: #667eea;
}

.answer-btn.selected {
  background: #667eea;
  border-color: #667eea;
}

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 8px;
}

.error-message {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;
}

/* ============================================================================
   QUESTION CARD (Draggable)
   ============================================================================ */
.questions-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.question-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease;
}

.question-card.dragging {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
  border-color: #667eea;
}

.question-card.editing {
  padding: 0;
  background: transparent;
  border: none;
}

.question-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.drag-handle {
  cursor: grab;
  padding: 8px;
  margin: -8px;
  border-radius: 8px;
  transition: background 0.2s;
}

.drag-handle:hover {
  background: rgba(255, 255, 255, 0.1);
}

.drag-handle:active {
  cursor: grabbing;
}

.drag-icon {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.4);
}

.question-number {
  font-size: 14px;
  font-weight: 600;
  color: #667eea;
  flex: 1 1;
}

.question-card-actions {
  display: flex;
  gap: 8px;
}

.question-text {
  font-size: 18px;
  margin-bottom: 16px;
  font-weight: 500;
  line-height: 1.5;
}

.question-options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.question-options span {
  display: flex;
  align-items: center;
  gap: 8px;
}

.question-options .correct-option {
  color: #10b981;
  font-weight: 600;
}

.option-indicator {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 11px;
  color: white;
  flex-shrink: 0;
}

.option-indicator.a { background: #ef4444; }
.option-indicator.b { background: #3b82f6; }
.option-indicator.c { background: #10b981; }
.option-indicator.d { background: #f59e0b; }

/* ============================================================================
   QUIZ PLAY SCREEN
   ============================================================================ */
.quiz-container {
  max-width: 700px;
  margin: 0 auto;
}

.quiz-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}

.quiz-progress {
  flex: 1 1;
  text-align: center;
  min-width: 200px;
}

.quiz-progress span {
  display: block;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}

.progress-bar {
  height: 8px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.quiz-title-small {
  background: rgba(255, 255, 255, 0.1);
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quiz-score {
  background: rgba(255, 255, 255, 0.1);
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
}

.quiz-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 24px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.quiz-question {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 32px;
  line-height: 1.4;
}

.quiz-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.quiz-option {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 24px;
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.03);
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
}

.quiz-option:hover:not(:disabled) {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.1);
}

.quiz-option:disabled {
  cursor: default;
}

.quiz-option.selected {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.2);
}

.quiz-option.correct {
  border-color: #10b981;
  background: rgba(16, 185, 129, 0.2);
  animation: pulse-correct 0.5s ease;
}

.quiz-option.incorrect {
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.2);
  animation: shake 0.5s ease;
}

.quiz-option.dimmed {
  opacity: 0.5;
}

@keyframes pulse-correct {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

.option-letter {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  flex-shrink: 0;
}

.option-text {
  flex: 1 1;
}

.result-icon {
  font-size: 20px;
  margin-left: auto;
}

.feedback {
  padding: 16px 24px;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 24px;
}

.feedback.correct {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.feedback.incorrect {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

/* ============================================================================
   QUIZ COMPLETE SCREEN
   ============================================================================ */
.quiz-complete {
  text-align: center;
  padding: 60px 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.complete-icon {
  font-size: 80px;
  margin-bottom: 24px;
}

.quiz-complete h2 {
  font-size: 32px;
  margin-bottom: 32px;
}

.final-score {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
}

.score-number {
  font-size: 72px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.score-divider {
  font-size: 48px;
  color: rgba(255, 255, 255, 0.3);
}

.score-total {
  font-size: 48px;
  color: rgba(255, 255, 255, 0.5);
}

.score-percentage {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 16px;
}

.complete-message {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 32px;
}

.complete-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

/* Results breakdown */
.results-breakdown {
  margin: 32px 0;
  text-align: left;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.results-breakdown h4 {
  margin-bottom: 16px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.result-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border-radius: 8px;
  margin-bottom: 8px;
  font-size: 14px;
}

.result-item.correct {
  background: rgba(16, 185, 129, 0.1);
}

.result-item.incorrect {
  background: rgba(239, 68, 68, 0.1);
}

.result-number {
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  min-width: 30px;
}

.result-status {
  font-size: 18px;
}

.result-item.correct .result-status {
  color: #10b981;
}

.result-item.incorrect .result-status {
  color: #ef4444;
}

.result-answer {
  color: rgba(255, 255, 255, 0.5);
  margin-left: auto;
}

/* Error state */
.error-state {
  text-align: center;
  padding: 60px 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.error-state h2 {
  font-size: 32px;
  margin-bottom: 16px;
}

.error-state p {
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 24px;
}

/* ============================================================================
   RESPONSIVE DESIGN
   ============================================================================ */
@media (max-width: 768px) {
  .stats-row {
    flex-direction: column;
  }
  
  .quiz-list-card {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .quiz-list-actions {
    width: 100%;
    justify-content: flex-end;
  }
  
  .quiz-info-display {
    flex-direction: column;
  }
  
  .quiz-info-actions {
    width: 100%;
    justify-content: flex-start;
  }
  
  .share-section {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .share-info {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .share-url {
    width: 100%;
  }
  
  .share-actions {
    width: 100%;
    justify-content: flex-end;
  }
  
  .question-options {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .hero h1 {
    font-size: 36px;
  }
  
  .quiz-card {
    padding: 24px;
  }
  
  .quiz-question {
    font-size: 20px;
  }
  
  .quiz-complete {
    padding: 40px 24px;
  }
  
  .score-number {
    font-size: 56px;
  }
  
  .question-form {
    padding: 20px;
  }
  
  .quiz-header {
    flex-direction: column;
    align-items: stretch;
  }
  
  .quiz-progress {
    order: -1;
  }
  
  .quiz-title-small {
    max-width: none;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;iFAEiF;AACjF;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;;iFAEiF;AACjF;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;iFAEiF;AACjF;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,0DAA0D;EAC1D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;iFAEiF;AACjF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;iFAEiF;AACjF;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;;iFAEiF;AACjF;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;;AAEvC;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;iFAEiF;AACjF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;;AAE3C;;iFAEiF;AACjF;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;iFAEiF;AACjF;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;iFAEiF;AACjF;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["/* ============================================================================\n   BASE STYLES\n   ============================================================================ */\n.app {\n  min-height: 100vh;\n  padding: 20px;\n}\n\n/* ============================================================================\n   BUTTONS\n   ============================================================================ */\n.btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-secondary {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.btn-secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-back {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.7);\n  padding: 8px 16px;\n}\n\n.btn-back:hover {\n  color: white;\n}\n\n.btn-delete {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n  padding: 8px 16px;\n  font-size: 14px;\n}\n\n.btn-delete:hover:not(:disabled) {\n  background: rgba(239, 68, 68, 0.3);\n}\n\n.btn-delete:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-edit {\n  background: rgba(102, 126, 234, 0.2);\n  color: #667eea;\n  padding: 8px 16px;\n  font-size: 14px;\n}\n\n.btn-edit:hover {\n  background: rgba(102, 126, 234, 0.3);\n}\n\n.btn-full {\n  width: 100%;\n  justify-content: center;\n}\n\n.btn-small {\n  padding: 8px 16px;\n  font-size: 14px;\n}\n\n/* ============================================================================\n   HOME SCREEN\n   ============================================================================ */\n.home-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding-top: 60px;\n}\n\n.hero {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.hero h1 {\n  font-size: 48px;\n  margin-bottom: 12px;\n  background: linear-gradient(135deg, #fff 0%, #a5b4fc 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.hero p {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 18px;\n  margin-bottom: 32px;\n}\n\n.hero-buttons {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.stats-row {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n.stats-card {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 20px;\n  padding: 32px;\n  text-align: center;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  flex: 1;\n}\n\n.stat-number {\n  font-size: 48px;\n  font-weight: 700;\n  color: #667eea;\n  display: block;\n}\n\n.stat-label {\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n/* Quiz list on home page */\n.quizzes-section {\n  margin-top: 40px;\n}\n\n.quizzes-section h3 {\n  margin-bottom: 20px;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.quizzes-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.quiz-list-card {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  transition: all 0.3s ease;\n}\n\n.quiz-list-card:hover {\n  border-color: rgba(102, 126, 234, 0.3);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.quiz-list-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.quiz-list-info h4 {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  color: white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.quiz-list-description {\n  margin: 0 0 8px 0;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.quiz-list-meta {\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 13px;\n}\n\n.quiz-list-actions {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.loading {\n  text-align: center;\n  padding: 60px 20px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* ============================================================================\n   MODAL\n   ============================================================================ */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal {\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);\n  border-radius: 20px;\n  padding: 32px;\n  max-width: 500px;\n  width: 100%;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 24px;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 28px;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.modal-close:hover {\n  color: white;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n\n/* ============================================================================\n   QUIZ MANAGER\n   ============================================================================ */\n.quiz-manager-container {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 32px;\n}\n\n.header h2 {\n  font-size: 28px;\n  margin: 0;\n}\n\n/* Quiz info card */\n.quiz-info-card {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 20px;\n  padding: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  margin-bottom: 24px;\n}\n\n.quiz-info-display {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.quiz-info-text h3 {\n  margin: 0 0 8px 0;\n  font-size: 24px;\n}\n\n.quiz-info-text p {\n  margin: 0 0 8px 0;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.quiz-meta {\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 14px;\n}\n\n.quiz-info-actions {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.quiz-info-edit .form-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n/* Share section */\n.share-section {\n  background: rgba(102, 126, 234, 0.1);\n  border-radius: 16px;\n  padding: 20px;\n  border: 1px solid rgba(102, 126, 234, 0.2);\n  margin-bottom: 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.share-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n.share-label {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.share-url {\n  background: rgba(0, 0, 0, 0.3);\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #a5b4fc;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  min-width: 0;\n}\n\n.share-actions {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n/* Add question section */\n.add-question-section {\n  margin-bottom: 40px;\n}\n\n.add-question-section h3 {\n  margin-bottom: 20px;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Questions section */\n.questions-section {\n  margin-top: 40px;\n}\n\n.questions-section h3 {\n  margin-bottom: 16px;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.drag-hint {\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.empty-questions {\n  text-align: center;\n  padding: 40px 20px;\n  color: rgba(255, 255, 255, 0.5);\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 16px;\n  border: 1px dashed rgba(255, 255, 255, 0.1);\n}\n\n/* ============================================================================\n   QUESTION FORM\n   ============================================================================ */\n.question-form {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 20px;\n  padding: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.question-form.editing {\n  background: rgba(102, 126, 234, 0.05);\n  border-color: rgba(102, 126, 234, 0.2);\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 14px 18px;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.2);\n  color: white;\n  font-size: 16px;\n  font-family: inherit;\n  transition: border-color 0.3s;\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.form-group textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.options-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n\n@media (max-width: 600px) {\n  .options-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.option-group {\n  position: relative;\n}\n\n.option-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.option-badge {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 14px;\n  color: white;\n}\n\n.option-badge.a { background: #ef4444; }\n.option-badge.b { background: #3b82f6; }\n.option-badge.c { background: #10b981; }\n.option-badge.d { background: #f59e0b; }\n\n.correct-answer-selector {\n  display: flex;\n  gap: 12px;\n}\n\n.answer-btn {\n  width: 50px;\n  height: 50px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  background: transparent;\n  color: white;\n  font-size: 18px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.answer-btn:hover {\n  border-color: #667eea;\n}\n\n.answer-btn.selected {\n  background: #667eea;\n  border-color: #667eea;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 8px;\n}\n\n.error-message {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n\n/* ============================================================================\n   QUESTION CARD (Draggable)\n   ============================================================================ */\n.questions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.question-card {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.2s ease;\n}\n\n.question-card.dragging {\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);\n  border-color: #667eea;\n}\n\n.question-card.editing {\n  padding: 0;\n  background: transparent;\n  border: none;\n}\n\n.question-card-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.drag-handle {\n  cursor: grab;\n  padding: 8px;\n  margin: -8px;\n  border-radius: 8px;\n  transition: background 0.2s;\n}\n\n.drag-handle:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.drag-handle:active {\n  cursor: grabbing;\n}\n\n.drag-icon {\n  font-size: 18px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.question-number {\n  font-size: 14px;\n  font-weight: 600;\n  color: #667eea;\n  flex: 1;\n}\n\n.question-card-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.question-text {\n  font-size: 18px;\n  margin-bottom: 16px;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.question-options {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.question-options span {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.question-options .correct-option {\n  color: #10b981;\n  font-weight: 600;\n}\n\n.option-indicator {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 11px;\n  color: white;\n  flex-shrink: 0;\n}\n\n.option-indicator.a { background: #ef4444; }\n.option-indicator.b { background: #3b82f6; }\n.option-indicator.c { background: #10b981; }\n.option-indicator.d { background: #f59e0b; }\n\n/* ============================================================================\n   QUIZ PLAY SCREEN\n   ============================================================================ */\n.quiz-container {\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n.quiz-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.quiz-progress {\n  flex: 1;\n  text-align: center;\n  min-width: 200px;\n}\n\n.quiz-progress span {\n  display: block;\n  margin-bottom: 8px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.progress-bar {\n  height: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.quiz-title-small {\n  background: rgba(255, 255, 255, 0.1);\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.8);\n  max-width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.quiz-score {\n  background: rgba(255, 255, 255, 0.1);\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-weight: 600;\n}\n\n.quiz-card {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 24px;\n  padding: 40px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.quiz-question {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 32px;\n  line-height: 1.4;\n}\n\n.quiz-options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.quiz-option {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 18px 24px;\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.03);\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: left;\n}\n\n.quiz-option:hover:not(:disabled) {\n  border-color: #667eea;\n  background: rgba(102, 126, 234, 0.1);\n}\n\n.quiz-option:disabled {\n  cursor: default;\n}\n\n.quiz-option.selected {\n  border-color: #667eea;\n  background: rgba(102, 126, 234, 0.2);\n}\n\n.quiz-option.correct {\n  border-color: #10b981;\n  background: rgba(16, 185, 129, 0.2);\n  animation: pulse-correct 0.5s ease;\n}\n\n.quiz-option.incorrect {\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.2);\n  animation: shake 0.5s ease;\n}\n\n.quiz-option.dimmed {\n  opacity: 0.5;\n}\n\n@keyframes pulse-correct {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.02); }\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-5px); }\n  75% { transform: translateX(5px); }\n}\n\n.option-letter {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.option-text {\n  flex: 1;\n}\n\n.result-icon {\n  font-size: 20px;\n  margin-left: auto;\n}\n\n.feedback {\n  padding: 16px 24px;\n  border-radius: 12px;\n  text-align: center;\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 24px;\n}\n\n.feedback.correct {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.feedback.incorrect {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n/* ============================================================================\n   QUIZ COMPLETE SCREEN\n   ============================================================================ */\n.quiz-complete {\n  text-align: center;\n  padding: 60px 40px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.complete-icon {\n  font-size: 80px;\n  margin-bottom: 24px;\n}\n\n.quiz-complete h2 {\n  font-size: 32px;\n  margin-bottom: 32px;\n}\n\n.final-score {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.score-number {\n  font-size: 72px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.score-divider {\n  font-size: 48px;\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.score-total {\n  font-size: 48px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.score-percentage {\n  font-size: 24px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-bottom: 16px;\n}\n\n.complete-message {\n  font-size: 20px;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 32px;\n}\n\n.complete-buttons {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* Results breakdown */\n.results-breakdown {\n  margin: 32px 0;\n  text-align: left;\n  max-width: 400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.results-breakdown h4 {\n  margin-bottom: 16px;\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.result-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 16px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.result-item.correct {\n  background: rgba(16, 185, 129, 0.1);\n}\n\n.result-item.incorrect {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.result-number {\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.6);\n  min-width: 30px;\n}\n\n.result-status {\n  font-size: 18px;\n}\n\n.result-item.correct .result-status {\n  color: #10b981;\n}\n\n.result-item.incorrect .result-status {\n  color: #ef4444;\n}\n\n.result-answer {\n  color: rgba(255, 255, 255, 0.5);\n  margin-left: auto;\n}\n\n/* Error state */\n.error-state {\n  text-align: center;\n  padding: 60px 40px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.error-state h2 {\n  font-size: 32px;\n  margin-bottom: 16px;\n}\n\n.error-state p {\n  color: rgba(255, 255, 255, 0.6);\n  margin-bottom: 24px;\n}\n\n/* ============================================================================\n   RESPONSIVE DESIGN\n   ============================================================================ */\n@media (max-width: 768px) {\n  .stats-row {\n    flex-direction: column;\n  }\n  \n  .quiz-list-card {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .quiz-list-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n  \n  .quiz-info-display {\n    flex-direction: column;\n  }\n  \n  .quiz-info-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n  \n  .share-section {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .share-info {\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .share-url {\n    width: 100%;\n  }\n  \n  .share-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n  \n  .question-options {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 600px) {\n  .hero h1 {\n    font-size: 36px;\n  }\n  \n  .quiz-card {\n    padding: 24px;\n  }\n  \n  .quiz-question {\n    font-size: 20px;\n  }\n  \n  .quiz-complete {\n    padding: 40px 24px;\n  }\n  \n  .score-number {\n    font-size: 56px;\n  }\n  \n  .question-form {\n    padding: 20px;\n  }\n  \n  .quiz-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .quiz-progress {\n    order: -1;\n  }\n  \n  .quiz-title-small {\n    max-width: none;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
